import { facultyImgArts } from "../../../static";
import FacultyName from "../../faculty/component/facultyName";

function ClubHome() {
    return (<div>
        <FacultyName name='Clubs' facultyImg={facultyImgArts} />
    </div>  );
}

export default ClubHome;